import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import ReactPixel from 'react-facebook-pixel';
import { database } from './App';
import classNames from 'classnames';
import strings from './components/language/language';
import bgImage from './food.png';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
// import Slider from 'react-slick';
import Inded from 'react-select';
import History from './history';
import Button from '@material-ui/core/Button';
import MyOrders from '@material-ui/icons/RestaurantMenu';
const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};
const groupBadgeStyles = {
  backgroundColor: '#EBECF0',
  borderRadius: '2em',
  color: '#172B4D',
  display: 'inline-block',
  fontSize: 12,
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '0.16666666666667em 0.5em',
  textAlign: 'center',
};

const formatGroupLabel = (data) => (
  <div style={groupStyles}>
    <span>{data.label}</span>
    <span style={groupBadgeStyles}>{data.options.length}</span>
  </div>
);

class ChooseArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
      field: null,
      areaChosen: false,
      startTime: 0,
      getColor: false,
    };
  }
  componentDidMount() {
    const startTime = new Date();
    this.setState({ startTime: startTime.getTime() / 1000 });
  }

  // Send to user a message from the restaurant that they can't deliver to this area
  sendAreaToChatfuel = (areaName, areaId, msgId, botId) => {
    var url =
      'https://api.chatfuel.com/bots/' +
      botId +
      '/users/' +
      msgId +
      '/send?chatfuel_token=mELtlMAHYqR0BvgEiMq8zVek3uYUK3OJMbtyrdNPTrQB9ndV0fM7lWTFZbM4MZvD&chatfuel_message_tag=PAIRING_UPDATE&chatfuel_block_name=not_available_area&area_name=' +
      areaName +
      '&area_id=' +
      areaId;
    // console.log('url' + url);
    fetch(url, { method: 'POST' })
      .then((response) => response.json())
      .catch((error) => console.log('Fetch Error =\n', error));
  };

  // handleBranches = (newVal, actionMeta) => {
  //   this.setState({ field: newVal });
  //   if (actionMeta.action === 'clear')  {
  //     // Clear the search to avoid crash
  //     console.log('Cleared');
  //   } else {
  //     // get categories inside the selected branch
  //     this.props.getCategories(newVal);
  //     // get branch name to send with the order
  //     this.props.getBranch(newVal.label, newVal.branch_id);
  //   }
  // }

  checkBranches = (chosenArea) => {
    const { getArea, getCategories, getBranch, branches } = this.props;

    // console.log(ChooseArea);

    // let newBranches = [];

    // get area name to send with the order
    getArea(chosenArea.name);

    const branchID = chosenArea.branch;

    // this.state.branches.forEach(branch => {
    //   branch.working_areas.forEach(area => {
    //     if (chosenArea.name === area.name || chosenArea.area_id === area.area_id) {
    //       newBranches.push(branch);
    //     }
    //   });
    // });

    getCategories(branches[branchID]);

    let fees = 0;

    branches[branchID].working_areas.forEach((area) => {
      if (
        area.label === chosenArea.name ||
        area.area_id === chosenArea.area_id
      ) {
        fees = area.fees;
      }
    });

    // get branch info to send with the order
    getBranch(branches[branchID], fees);

    // If one branch in that area then user will redirected automatically to that branch
    // if (newBranches.length === 1) {

    // }
    // else {
    //   // else will have to choose the closest branch
    //   this.setState({ branches: newBranches, areaChosen: true });
    // }
  };

  handleAreas = (newValue, actionMeta) => {
    const endTime = new Date();
    const duration = endTime.getTime() / 1000 - this.state.startTime;

    ReactPixel.trackCustom(
      `desktop - ${this.props.restaurant_name} - select area duration`,
      {
        duration,
        restaurantName: this.props.restaurant_name,
        userID: this.props.messenger_user_id,
      }
    );
    ReactPixel.trackCustom('desktop - menu view');
    ReactPixel.trackCustom(
      `desktop - ${this.props.restaurant_name} - menu view`
    );

    this.setState({ value: newValue });
    if (actionMeta.action === 'clear') {
      // clearing the search otherwise it will crash
      console.log('Cleared');
    } else if (newValue.condition) {
      // loop through branch working areas to match the one selected
      this.checkBranches(newValue);
    } else if (!newValue.condition) {
      // increase counter , send user id & update database and wont be able to order
      const arr = [...this.state.areas];

      arr.forEach((area, index) => {
        if (area.name === newValue.name) {
          area.messenger_user_id
            ? area.messenger_user_id.push(this.props.messenger_user_id)
            : (area.messenger_user_id = [this.props.messenger_user_id]);
          this.sendAreaToChatfuel(
            area.name,
            index,
            this.props.messenger_user_id,
            this.props.messenger_bot_id
          );
          area.counter += 1;
          database
            .ref(`restaurants/0/${this.props.restaurant_name}/areas`)
            .update({ working_areas: arr });
        }
      });
      this.props.history.push('/not-available');
    }
  };

  render() {
    const { classes, areas } = this.props;
    const { value, branches, areaChosen, field } = this.state;
    const { restaurant_name } = this.props;

    let gropedAreas = areas.reduce((allAreas, area) => {
      allAreas = {
        ...allAreas,
        [area.city]: allAreas[area.city]
          ? [...allAreas[area.city], { ...area, value: area }]
          : [{ ...area, value: area }],
      };

      return allAreas;
    }, {});

    gropedAreas = Object.entries(gropedAreas).reduce(
      (allAreas, [key, value]) => {
        allAreas = [
          ...allAreas,
          ...(allAreas.some((ar) => ar.label === key)
            ? []
            : [{ label: key, options: value }]),
        ];
        return allAreas;
      },
      []
    );
    console.log('COLOR', this.props.color);
    console.log('display name', this.props.displayName);

    return (
      <div className={classes.top1}>
        <div className={classes.overlay}>
          <div
            id='area-header'
            style={{ marginTop: this.props.logo ? 50 : 100 }}
          >
            {this.props.logo ? (
              <img
                className={classes.logo}
                src={this.props.logo.logoUrlRestaurant}
              />
            ) : (
              <h3 className='name'>{this.props.displayName}</h3>
            )}
          </div>
          <Button
            className={classNames(
              'my-order',
              this.props.logo ? 'my-order' : 'my-order-mobile',
              classes.myOrders
            )}
            style={{
              color: this.props.color ? this.props.color : '#70142b',
              margin: 'auto',
            }}
            onClick={() => {
              this.props.history.push('/history');
            }}
          >
            <span
              style={{
                position: 'relative',
                bottom: 4,
                fontSize:
                  (this.props.lang === 'ar') | (this.props.lang === 'qrAR')
                    ? 17
                    : 14,
              }}
            >
              <MyOrders style={{ position: 'relative', top: 7, right: 7 }} />
              {strings.past_orders}
            </span>
          </Button>
          <h1
            className='center'
            style={{ color: this.props.color, marginTop: 20 }}
          >
            {strings.choose_your_area}
          </h1>
          <div
            style={{
              border: this.props.color
                ? `2px solid ${this.props.color}`
                : '2px solid #70142b',
              width: '45%',
              margin: 'auto',
              borderRadius: 7,
            }}
            className='area-dropdown-select'
          >
            <Inded
              onChange={this.handleAreas}
              options={gropedAreas}
              formatGroupLabel={formatGroupLabel}
            />
          </div>
        </div>
      </div>
    );
  }
}

const styles = (theme) => ({
  top1: {
    position: 'absolute',
    background: `url(${bgImage}) no-repeat center center`,
    // backgroundSize: 'cover',
    height: '100%',
    width: '100%',
    minHeight: 650,
    backgroundRepeat: 'repeat',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: '#00000014',
  },
  button: {
    backgroundColor: 'dimgrey',
    border: 'none',
    padding: '15px 85px',
    color: '#fff',
    fontSize: 20,
    borderRadius: 5,
    marginTop: 60,
    outline: 0,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#848484',
    },
  },
  h3: {
    background: '#70142C',
    color: '#fff',
    fontSize: 36,
    lineHeight: '100px',
    margin: 10,
    padding: '2%',
    position: 'relative',
    textAlign: 'center',
  },
  logo: {
    width: 200,
    borderRadius: 10,
    margin: 'auto',
    display: 'block',
    [theme.breakpoints.down('sm')]: {
      width: 120,
    },
  },
});
export default withStyles(styles)(ChooseArea);



// WEBPACK FOOTER //
// ./src/ChooseArea.js